import Vue from 'vue'
import Vuex from 'vuex'

import authModule from './auth/index'
import farmModule from "./farm/index"
import AnimalModule from "./animal/index"
import DrugModule from "./drug/index"
import NTRModule from "./ntr/index"
import ActionList from "./action-list/index"
import i18n from '@/plugins/i18n';


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    drawer:false,
    language: i18n.locale,
  },
  mutations: {
    SET_DRAWER(state, payload) {
      state.drawer = payload;
    },
    SET_LANGUAGE(state, payload) {
      state.language = payload;
      i18n.locale = payload;
      localStorage.setItem('LANGUAGE',payload);
    }
  },
  actions: {
  },
  modules: {
      auth: authModule,
      farm: farmModule,
      animal: AnimalModule,
      drug:DrugModule,
      ntr:NTRModule,
      action_list: ActionList
  }
})
